import React from 'react'
import { VStack, Divider } from '@chakra-ui/react'
import { CreditCardOption } from './CreditCardOption'
import { PayPayOption } from './PayPayOption'

export const PaymentMethodSelector = ({ selectedMethod, onMethodChange }) => (
  <VStack w="100%" spacing={0} bg="white" borderRadius="4px" border="1px solid" borderColor="divider.light">
    <CreditCardOption isSelected={selectedMethod === 'credit_card'} onChange={() => onMethodChange('credit_card')} />
    <Divider borderColor="divider.light" />
    <PayPayOption isSelected={selectedMethod === 'paypay'} onChange={() => onMethodChange('paypay')} />
  </VStack>
)
